export interface IDropdownModelString {
  id: string;
  text: string;
}

export class DropdownModelString implements IDropdownModelString {
    constructor(public id: string, public text: string) { }
}
